module.exports = __webpack_public_path__ + "media/images/plans/img_proposal1-e878eb9e8824ba62719078553c19c963.jpg";